export default __webpack_public_path__ + "static/blockthrough-6ca757de3eaea9e4ec7ec65c9aacb623.svg";